export const environment = {
	production: true,
	url: "https://api-mainsite.policystreet.app",
	motorUrl: "https://api-motor.policystreet.app"
};
